// extracted by mini-css-extract-plugin
module.exports = {"Card":"RnDResourceChart_Card__12NSd","Header":"RnDResourceChart_Header__1_GTV"};